export default  {"src":"/_next/static/image/img/cerahKids/0-3.0d5c2eb5f157be82cf6d4d73bddcc4de.svg","height":512,"width":512};